export const PIXELENTRY_MIGRATION_BUTTON_TESTID = 'pixel-entry-convert-pixels-btn';

// pixel resizing toolbar width (with `platform_editor_controls` enabled)
export const PIXEL_RESIZING_TOOLBAR_WIDTH = 240;
export const PIXEL_VIEW_MODE_TOOLBAR_WIDTH = 204;
